var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _vm._l(_vm.charts[0], function (data, index) {
            return _c(
              "v-col",
              {
                key: "" + index + data,
                attrs: { cols: "12", sm: "6", md: "6" },
              },
              [
                _vm.charts[1][index].title === "Generation Mix"
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6" } },
                          [
                            _c("v-select", {
                              attrs: { label: "Year", items: _vm.yearItems },
                              model: {
                                value: _vm.generationMixYear,
                                callback: function ($$v) {
                                  _vm.generationMixYear = $$v
                                },
                                expression: "generationMixYear",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.charts[1][index].title === "Duck Curve"
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", sm: "6" } },
                          [
                            _c("v-select", {
                              attrs: { label: "Year", items: _vm.yearItems },
                              model: {
                                value: _vm.duckCurveYear,
                                callback: function ($$v) {
                                  _vm.duckCurveYear = $$v
                                },
                                expression: "duckCurveYear",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("Plotly", {
                  attrs: {
                    data: data,
                    layout: _vm.charts[1][index],
                    toImageButtonOptions: _vm.chartDownloadName(
                      _vm.caseName,
                      "PC",
                      _vm.charts[1][index].title
                    ),
                  },
                }),
              ],
              1
            )
          }),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [_c("ChartStream", { attrs: { data: _vm.duckCurve } })],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }